
global.constants = {
  overtime: 60 * 60 * 24,

  notGoHome:['research','news','search','references','views','searchs'],
  userInput:['reference','section','collection','taxonomy','oceanic'],
  myWebsite:['127.0.0.1:3000']
 
};
